import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { memo, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { ensureTrailingSlash } from "../../../../util/seo";
import FooterContext from "../../footer-context";
import { SocialIconsList, SocialIconsListItem } from "./styled-components";
import socials from "./socials";
import { jsx as _jsx } from "react/jsx-runtime";
var SocialIcons = function SocialIcons(_ref) {
  var onClick = _ref.onClick;
  var _useContext = useContext(FooterContext),
    palette = _useContext.palette;
  var handleClick = useCallback(function (name, href) {
    return function (event) {
      onClick({
        key: name,
        label: name,
        href: href,
        event: event
      });
    };
  }, [onClick]);
  return /*#__PURE__*/_jsx(SocialIconsList, {
    children: socials.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 3),
        name = _ref3[0],
        href = _ref3[1],
        backgroundPosition = _ref3[2];
      return /*#__PURE__*/_jsx(SocialIconsListItem, {
        backgroundPosition: backgroundPosition,
        palette: palette,
        children: /*#__PURE__*/_jsx("a", {
          "data-gtm-event": "nav_element--footer",
          href: ensureTrailingSlash(href),
          rel: "nofollow noreferrer noopener",
          target: "_blank",
          onClick: handleClick(name, href),
          children: name
        })
      }, name);
    })
  });
};
SocialIcons.propTypes = {
  onClick: PropTypes.func
};
SocialIcons.defaultProps = {
  onClick: function onClick() {}
};
export default /*#__PURE__*/memo(SocialIcons);